import { FieldGroupColumn } from 'models/response';
import { DataGridRow } from 'components/DataGrid';
import { DEFAULT_WIDTH_Q3_COLUMNS } from 'utils/constants';

export function getInitialTextColumnWidths(
  cols: FieldGroupColumn[],
  rows: DataGridRow[],
  defaultWidth: number = DEFAULT_WIDTH_Q3_COLUMNS,
): { [key: string]: number } {
  const widths: { [key: string]: number } = {};
  const MAX_TEXT_WIDTH = 400;
  cols.forEach((col) => {
    if (col.dataType === 0 && col.type === 0) {
      const maxLength = rows.reduce((max, row) => {
        const value = row[col.code];
        return value && typeof value === 'string' && value.length > max ? value.length : max;
      }, 0);
      let estimatedWidth = maxLength * 6.7;
      estimatedWidth = Math.max(defaultWidth, estimatedWidth);
      widths[col.code] = Math.min(estimatedWidth, MAX_TEXT_WIDTH);
    }
  });
  return widths;
}
